import * as React from 'react'

const IconTeacher = (props) => {
  const { color } = props
  return (
    <svg
      width={50}
      height={50}
      viewBox='0 0 50 50'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <defs>
        <path id='icon-teacher_svg__a' d='M0 0h40.084v40.115H0z' />
      </defs>
      <g fill='none' fillRule='evenodd'>
        <g transform='translate(5.208 5.208)'>
          <mask id='icon-teacher_svg__b' fill='#FFF'>
            <use xlinkHref='#icon-teacher_svg__a' />
          </mask>
          <path
            d='M38.426 29.611H24.798a36.241 36.241 0 0 0-1.354-3.3l9.786-7.174a.83.83 0 0 0-.981-1.339l-9.56 7.011a31.377 31.377 0 0 0-1.395-2.367 9.548 9.548 0 0 0 2.173-6.07c0-5.289-4.302-9.59-9.59-9.59s-9.59 4.301-9.59 9.59c0 2.3.816 4.414 2.173 6.07-1.6 2.461-2.724 4.97-3.504 7.17H1.658V1.658h36.768V29.61zm-20.284-7.07c-.089.06-.18.12-.28.18-.06.037-.12.075-.182.11-.913.518-2.246 1.01-3.99 1.037-4.053-.1-7.32-3.42-7.32-7.496 0-4.14 3.368-7.507 7.507-7.507 4.139 0 7.506 3.367 7.506 7.507a7.498 7.498 0 0 1-3.241 6.169zm5.05 14.06c-1.857.652-4.98 1.43-9.315 1.43-4.334 0-7.458-.778-9.316-1.43a1.441 1.441 0 0 1-.941-1.665c.475-2.315 1.646-6.652 4.285-10.892 1.004.873 2.8 1.917 5.651 1.917.058 0 .109-.007.165-.008.052.001.103.008.156.008a9.522 9.522 0 0 0 4.864-1.34c.035-.02.064-.04.099-.06.145-.088.293-.174.434-.27a8.68 8.68 0 0 0 .506-.358c2.689 4.275 3.875 8.668 4.354 11.002a1.441 1.441 0 0 1-.942 1.666zM39.255 0H.83A.83.83 0 0 0 0 .83v29.61c0 .458.372.83.83.83h1.578a36.422 36.422 0 0 0-.829 3.248 3.55 3.55 0 0 0 2.292 4.049c2.01.706 5.379 1.548 10.006 1.548 4.627 0 7.995-.842 10.005-1.548a3.55 3.55 0 0 0 2.293-4.05 36.927 36.927 0 0 0-.83-3.247h13.91a.83.83 0 0 0 .83-.83V.83a.83.83 0 0 0-.83-.83z'
            fill={color || '#FFF'}
            mask='url(#icon-teacher_svg__b)'
          />
        </g>
        <path
          d='M25.251 11.787h15.111a.698.698 0 0 0 0-1.396H25.251a.697.697 0 1 0 0 1.396m15.112 2.793H29.84a.697.697 0 1 0 0 1.395h10.522a.697.697 0 1 0 0-1.396m.001 4.188h-7.997a.698.698 0 0 0 0 1.396h7.997a.697.697 0 1 0 0-1.396'
          fill={color || '#FFF'}
        />
      </g>
    </svg>
  )
}

export default IconTeacher
